import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

export default function HeroSection() {
  const { t } = useTranslation();

  return (
    <section className="relative w-full h-[420px] md:h-[600px] overflow-hidden">
      <img
        src="https://readdy.ai/api/search-image?query=Entertainment%20news%20abstract%20background%2C%20dramatic%20dark%20stage%20with%20warm%20spotlight%20beams%2C%20mysterious%20silhouettes%2C%20artistic%20blurred%20paparazzi%20scene%2C%20luxurious%20red%20carpet%20texture%2C%20cinematic%20atmosphere%2C%20golden%20and%20amber%20accents%20on%20deep%20charcoal%20background&width=1800&height=1000&seq=home-hero-bg&orientation=landscape"
        alt="51吃瓜每日大赛 - 娱乐爆料背景"
        title="51吃瓜每日大赛 - 娱乐爆料背景"
        className="absolute inset-0 w-full h-full object-cover object-top"
      />
      <div className="absolute inset-0 bg-gradient-to-b from-black/50 via-black/35 to-black/20"></div>

      <div className="relative z-10 flex flex-col items-center justify-center h-full w-full px-4 md:px-8 text-center">
        <h1 className="w-full font-heading text-3xl md:text-5xl lg:text-6xl text-background-50 tracking-tight leading-tight">
          {t('home_hero_title1')}
          <br />
          {t('home_hero_title2')}
        </h1>
        <p className="mt-5 md:mt-6 max-w-[620px] text-sm md:text-base text-background-300 leading-relaxed">
          {t('home_hero_subtitle')}
        </p>
        <div className="flex items-center gap-3 mt-7 md:mt-8">
          <Link
            to="#hot-news"
            className="px-7 py-3 rounded-full bg-primary-500 text-background-50 text-sm md:text-base font-medium hover:bg-primary-600 transition-all duration-200 whitespace-nowrap cursor-pointer flex items-center gap-2"
          >
            {t('home_hero_cta')}
            <span className="w-4 h-4 flex items-center justify-center">
              <i className="ri-arrow-right-line text-base"></i>
            </span>
          </Link>
          <Link
            to="#latest-news"
            className="px-7 py-3 rounded-full border border-background-300/60 text-background-50 text-sm md:text-base font-medium hover:bg-background-50/10 transition-all duration-200 whitespace-nowrap cursor-pointer"
          >
            {t('home_hero_viewMore')}
          </Link>
        </div>
      </div>
    </section>
  );
}